module.exports = __webpack_public_path__ + "static/media/quiron@3x.58921d7b.jpg";